import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class SettingsAgentsBaseController extends Controller {
  @service declare router: RouterService;

  @action
  goToListPage() {
    this.router.transitionTo('settings.agents.list');
  }
}
